import { format } from 'date-fns'
import {
  LegendStatusIcon,
  VersionChip,
} from '@/features/legends/components/LegendStatus'
import type { LegendStatus } from '@/features/legends/legend-status'
import styles from './VersionNotes.module.css'

export interface VersionNotesProps {
  name: string
  version: number
  status: LegendStatus
  datePublished: Date | null
  /**
   * The display name of who published the version.
   */
  publishedBy?: string
  notes?: string
  testId?: string
}

/**
 * The notes of a published version, with who published it and when.
 */
export function VersionNotes({
  name,
  version,
  status,
  datePublished,
  publishedBy,
  notes,
  testId,
}: VersionNotesProps) {
  return (
    <div className={styles.root} data-test={testId}>
      <VersionChip version={version} status={status} />
      <div className={styles.content}>
        <p className={styles.title}>
          {name} V{version}
        </p>
        <p className={styles.byline}>
          <LegendStatusIcon status={status} />
          <span>
            Published
            {datePublished && <> on {format(datePublished, 'PPp')}</>}
            {publishedBy && (
              <>
                {' '}
                by <strong className={styles.publisher}>{publishedBy}</strong>
              </>
            )}
          </span>
        </p>
        {notes && <p className={styles.notes}>{notes}</p>}
      </div>
    </div>
  )
}
